export default {
	MAX_UPLOAD_VIDEO_SIZE_REGULAR_USER: 100,
	MAX_UPLOAD_VIDEO_SIZE_SUPPORT_CONTENT_USER: 200,
}
